import { z } from 'zod';

export const PostMaterialQuotePathParametersSchema = z.object({
    id: z.string().uuid(),
});
